/** @format */

import React from 'react';
import { Card, Col, Row } from 'antd';
import { Customer } from '../types/customer';
import { formatDateOfBirth } from '../utils/customerUtils';

interface FamilyInfoCardsProps {
  customer: Customer;
}

const FamilyInfoCards: React.FC<FamilyInfoCardsProps> = ({ customer }) => {
  if (!customer.spouseInfo && (!customer.dependentsInfo || customer.dependentsInfo.length === 0)) {
    return null;
  }

  return (
    <Row gutter={[16, 16]} style={{ marginTop: '20px' }}>
      <Col sm={24} md={24} lg={24} xl={24}>
        <div className="form-heading">
          <span>Spouse and Dependent</span>
        </div>
      </Col>

      {customer.spouseInfo && (
        <Col span={8}>
          <Card title="Spouse Information">
            <div style={{ padding: '10px' }}>
              <p>
                <strong>First Name:</strong> {customer.spouseInfo.firstName}
              </p>
              <p>
                <strong>Last Name:</strong> {customer.spouseInfo.lastName}
              </p>
              <p>
                <strong>Date of Birth:</strong> {formatDateOfBirth(customer.spouseInfo)}
              </p>
              <p>
                <strong>SSN:</strong> {customer.spouseInfo.SSN || customer.spouseInfo.ssn}
              </p>
            </div>
          </Card>
        </Col>
      )}

      {customer.dependentsInfo && customer.dependentsInfo.length > 0 && (
        <Col span={8}>
          <Card title="Dependents Information">
            {customer.dependentsInfo.map((dependent, index) => (
              <div key={index} style={{ padding: '10px' }}>
                <p>
                  <strong>First Name:</strong> {dependent.firstName}
                </p>
                <p>
                  <strong>Last Name:</strong> {dependent.lastName}
                </p>
                <p>
                  <strong>Date of Birth:</strong> {formatDateOfBirth(dependent)}
                </p>
                <p>
                  <strong>SSN:</strong> {dependent.SSN}
                </p>
              </div>
            ))}
          </Card>
        </Col>
      )}
    </Row>
  );
};

export default FamilyInfoCards;
